var logoInstagram = "https://shopfront-cdn.tekoapis.com/static/e9acf6e5447bc6f5.svg";

export { logoInstagram as default };
